export enum DegreesProgramsModalState {
  CLOSED = "CLOSED",
  ADD_DEGREE = "ADD_DEGREE",
  CHANGE_DEGREE_NAME = "CHANGE_DEGREE_NAME",
  DELETE_DEGREE = "DELETE_DEGREE",
}
